export default __webpack_public_path__ + "static/media/badawi_2.06070196.jpg";